<template>
  <div class="accordion">
    <accordion-element
      v-for="(element, index) of elements"
      ref="elements"
      :key="index"
      :title="element.title"
      :id="element.id"
      :content="element.content"
      :button="element.button"
      :opened="openedElements.indexOf(index) !== -1"
      @open="$_openElement(index)"
      @close="$_closeElement(index)" />
  </div>
</template>

<script>
import _ from 'lodash'
import AccordionElement from './Accordion/AccordionElement.vue'

export default {
  components: {
    AccordionElement
  },
  data: () => ({
    openedElements: [],
    beforeAnimation: new Promise((resolve, reject) => resolve())
  }),
  props: {
    elements: {
      type: Array,
      required: true
    }
  },
  methods: {
    async $_openElement (index) {
      // define working element
      const currentElement = this.$refs.elements[index]

      // define to close elements
      const toClose = _.filter(this.$refs.elements, element => currentElement !== element)

      // wait for every close
      await Promise.all(_.map(toClose, element => element.close()))

      // set single open element
      this.openedElements = [index]

      // scroll to point
      this.$_scrollToElement(currentElement.$el)
    },
    $_closeElement (index) {
      this.openedElements = _.filter(this.openedElements, element => element !== index)
    },
    $_scrollToElement (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      })
    }
  }
}
</script>

<style lang="scss">
.accordion {
  margin-bottom: 10rem;
}
</style>
